var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPinterestWhite = function SvgPinterestWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.051,
    height: 18.058,
    viewBox: "0 0 18.051 18.058",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pinterest-white",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_10",
    "data-name": "Exclusion 10",
    d: "M-3317.975,956.057a9.037,9.037,0,0,1-9.025-9.029,9.037,9.037,0,0,1,9.025-9.029,9.037,9.037,0,0,1,9.025,9.029A9.037,9.037,0,0,1-3317.975,956.057Zm-.354-11.14c-.584,0-1.025.562-1.025,1.307a1.452,1.452,0,0,0,.162.74s-.016.071-.041.182c-.136.6-.55,2.406-.637,2.76a5.439,5.439,0,0,0-.018,1.964l0,.025a.066.066,0,0,0,.068.057.071.071,0,0,0,.058-.028l.008-.01a5.415,5.415,0,0,0,.953-1.7c.051-.181.252-.959.368-1.407l.008-.031a1.485,1.485,0,0,0,1.3.571c1.687,0,2.865-1.442,2.865-3.505a2.851,2.851,0,0,0-.856-2.024,3.491,3.491,0,0,0-2.5-.979,3.515,3.515,0,0,0-3.8,3.271,1.988,1.988,0,0,0,1.086,2,.245.245,0,0,0,.093.02.179.179,0,0,0,.175-.149c.012-.044.046-.124.078-.2l0-.009a2.184,2.184,0,0,0,.08-.208.253.253,0,0,0-.075-.293,1.332,1.332,0,0,1-.347-.964,2.414,2.414,0,0,1,2.556-2.6,1.992,1.992,0,0,1,2.208,2.032c0,1.585-.709,2.736-1.686,2.736a.891.891,0,0,1-.713-.313.741.741,0,0,1-.125-.646c.057-.238.133-.484.208-.721l0-.015a4.3,4.3,0,0,0,.257-1.124A.661.661,0,0,0-3318.329,944.917Z",
    transform: "translate(3327 -938)",
    fill: "#fff"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPinterestWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pinterest-white.ed10c973.svg";
export { ForwardRef as ReactComponent };